import React from 'react'
import Layout from '../../NewComponent/LayoutAdmin/Layout';
import Index from '../../Component/Admin/managePermissions';
export default function ManagePermissions() {
  return (
    <Layout>
        <Index/>
    </Layout>
  )
}
